import { SEARCH_PAGE_LOCATION } from '@disco/state-management/selectors/media'
import React, { useMemo } from 'react'

import type { Track } from 'types/track'

import MediaOverlay from 'components/common/media-overlay'
import TrackArtwork from 'components/common/tracks/track-artwork'
import { Flex, Text } from 'components/ds'
import type { SearchColumnProps } from 'components/search/search-columns/types'
import { HoverProvider } from 'components/ui/hover-provider'

import styles from './track-title-column.module.css'

export const TrackTitleColumn = React.memo(({ info }: SearchColumnProps) => {
  const name = info.getValue<string>()
  const track = info.row.original as Track

  // Get tracklist from table meta (passed from SearchPage via DataTable)
  const tracklist = (info.table.options.meta as { tracklist?: number[] })
    ?.tracklist

  const playbackContext = useMemo(
    () => ({
      type: track.type,
      playbackLocation: SEARCH_PAGE_LOCATION,
      tracklist,
    }),
    [track.type, tracklist],
  )

  // Dynamic width computed from CSS variable for column sizing
  const dynamicWidth = useMemo(
    () =>
      `calc(var(--col-${String(info.column.id)
        .toLowerCase()
        .replace(/\s+/g, '-')}-size) * 1px - 32px)`,
    [info.column.id],
  )

  return (
    <Flex align="center" gap="2">
      <HoverProvider>
        <Flex width="24px" height="24px">
          <MediaOverlay
            track={track}
            mediaSource="in-app"
            playbackContext={playbackContext}
            iconSize={12}
          >
            <TrackArtwork track={track} />
          </MediaOverlay>
        </Flex>
      </HoverProvider>
      <Flex className={styles.titleText} width={dynamicWidth} translate="no">
        <Text>{name}</Text>
      </Flex>
    </Flex>
  )
})

TrackTitleColumn.displayName = 'TrackTitleColumn'
